import React from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'reactstrap'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import {
  Container,
  Content,
  Description,
  Image,
  ImageWrapper
} from './AboutStyledComponents'

import NewHeader from '../../components/layout/NewHeader/NewHeader'
import selling from '../../assets/images/aboutUs/selling.png'
import cofounders from '../../assets/images/aboutUs/oliver_and_heida.png'
import easyRetail2 from '../../assets/images/aboutUs/Hausmart-example2.jpg'

const About = React.memo(({ breadcrumb }) => {
  return (
    <React.Fragment>
      <NewHeader breadcrumbTitle={breadcrumb}>
        <h1 className='text-center'>
          {' '}
          <FormattedMessage id='aboutUs.pageTitle' />
        </h1>
      </NewHeader>
      <Container>
        <Row>
          <Col md={{ size: 10, offset: 1 }}>
            <Content>
              <Col md='6'>
                <Description>
                  <FormattedHTMLMessage id='aboutUs.aboutUsText' />
                </Description>
              </Col>
              <ImageWrapper md='6'>
                <Image src={selling} alt='Genevive store'/>
              </ImageWrapper>
            </Content>
            <Content reverse='true'>
              <ImageWrapper md='6'>
                <Image src={easyRetail2} alt='Example store' />
              </ImageWrapper>
              <Col md='6'>
                <Description>
                  <FormattedHTMLMessage id='aboutUs.payments' />
                </Description>
                <Description>
                  <FormattedHTMLMessage id='aboutUs.hausmartDescription' />
                </Description>
              </Col>
            </Content>
            <Content>
              <Col md='6'>
                <Description>
                  <FormattedHTMLMessage id='aboutUs.coFounders' />
                </Description>
              </Col>
              <ImageWrapper md='6'>
                <Image src={cofounders} alt='Founders Heiða and Oliver'/>
              </ImageWrapper>
            </Content>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  )
})

About.displayName = 'About'

About.propTypes = {
  breadcrumb: PropTypes.string.isRequired
}

export default About
